//@flow
export const size = {
  mobileXS: 320,
  mobileS: 360,
  mobileM: 375,
  mobileL: 425,
  desktopMobile: 500,
  tabletS: 640,
  tablet: 767,
  tabletM: 860,
  tabletXL: 961,
  laptop: 1080,
  laptopL: 1440,
  desktop: 2560,
};
export const device = Object.keys(size).reduce(
  (acc: Record<typeof size, Function>, key: typeof size) => {
    acc[key] = (style: String) =>
      `@media (min-width: ${size[key]}px) { ${style} }`;
    return acc;
  },
  {}
);



// WEBPACK FOOTER //
// ./utils/breakPoints.js